var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgWrong = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 5.37644e-05C7.21997 5.37644e-05 5.47991 0.527895 3.99987 1.51683C2.51983 2.50576 1.36628 3.91137 0.685088 5.5559C0.00389969 7.20044 -0.174331 9.01004 0.172936 10.7559C0.520203 12.5017 1.37737 14.1053 2.63604 15.364C3.89472 16.6227 5.49836 17.4799 7.24419 17.8271C8.99002 18.1744 10.7996 17.9962 12.4442 17.315C14.0887 16.6338 15.4943 15.4802 16.4832 14.0002C17.4722 12.5201 18 10.7801 18 9.00005C18.0041 7.81701 17.7741 6.64484 17.3233 5.55106C16.8724 4.45728 16.2096 3.4635 15.3731 2.62696C14.5366 1.79042 13.5428 1.12764 12.449 0.676795C11.3552 0.225953 10.183 -0.00404237 9 5.37644e-05V5.37644e-05ZM13.5 12.2401L12.24 13.5001L9 10.2601L5.76 13.5001L4.5 12.2401L7.74 9.00005L4.5 5.76005L5.76 4.50005L9 7.74005L12.24 4.50005L13.5 5.76005L10.26 9.00005L13.5 12.2401Z",
    fill: "#CC0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWrong);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "a354a1efa448a16bb6c72ddad7dfa7bb.svg";